import { File } from 'lucide-react';
import type { Source } from '@/data/fixtures';
import { useSourceFileUrl } from '@/hooks/lesson/useSources';
import { UnsupportedPreview } from '@/components/features/learning/sources/viewers/shell/ViewerStates';
import { ViewerShell } from '@/components/features/learning/sources/viewers/shell/ViewerShell';

interface UnsupportedFileViewerProps {
  source: Source;
}

/**
 * Fallback for formats the layered viewer doesn't render in-page yet -
 * legacy office formats (.abw, .hwp), audio, eml/msg, etc. Shows a
 * download CTA that fetches the presigned URL on demand.
 */
export function UnsupportedFileViewer({ source }: UnsupportedFileViewerProps) {
  const { data } = useSourceFileUrl(source.id);

  const handleDownload = () => {
    if (data?.url) {
      window.open(data.url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <ViewerShell sourceId={source.id} icon={File} label='File' tone='neutral'>
      <UnsupportedPreview
        filename={source.original_filename || source.name}
        onDownload={data?.url ? handleDownload : undefined}
      />
    </ViewerShell>
  );
}
